import { render, staticRenderFns } from "./UnidadeAtendimentoSetting.vue?vue&type=template&id=d5cb4f20"
import script from "./UnidadeAtendimentoSetting.vue?vue&type=script&lang=js"
export * from "./UnidadeAtendimentoSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports